import { Button } from "@/components/ui/button";
import { Calendar, X } from "lucide-react";
import { useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

export default function UserInterviewBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const isMobile = useIsMobile();

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 border-b border-primary/20 py-3 px-4">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row md:items-center justify-center gap-2 md:gap-4 text-sm">
          <div className="flex items-center gap-2 text-primary font-medium flex-1">
            <Calendar className="h-4 w-4 flex-shrink-0" />
            <span className="text-left md:text-center">
              Help us build a better Habitualy! We'd love to learn about your experience, what features you love, and how we can improve. In exchange, enjoy a free lifetime subscription.
            </span>
          </div>
          <div className="flex items-center justify-center md:justify-start gap-2 flex-shrink-0">
            <Button
              size="sm"
              className="bg-primary hover:bg-primary/90 text-primary-foreground h-7 px-3 text-xs whitespace-nowrap"
              asChild
            >
              <a
                href="https://calendar.notion.so/meet/abdullahsiddiqi/habitualy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Meeting
              </a>
            </Button>
            <button
              onClick={() => setIsVisible(false)}
              className="text-muted-foreground hover:text-foreground transition-colors p-1 flex-shrink-0"
              aria-label="Close banner"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
